import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";

export const SET_UNITS = "SET_UNITS";
export const SET_UNITS_LOADING = "SET_UNITS_LOADING";
export const SET_UNITS_ERROR = "SET_UNITS_ERROR";

const setError = (dispatch, error) => {
  dispatch({
    type: SET_UNITS_ERROR,
    error: error?.response?.data?.message || error?.message || "Terjadi kesalahan pada data unit."
  });
};

export const fetchUnits = (limit = 100, page = 1, search = "") => async (dispatch) => {
  dispatch({ type: SET_UNITS_LOADING, status: true });
  try {
    const response = await authorizedAxios.get("/units", { params: { limit, page, search } });
    dispatch({ type: SET_UNITS, data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error);
    return null;
  } finally {
    dispatch({ type: SET_UNITS_LOADING, status: false });
  }
};

export const addUnit = (data) => async (dispatch) => {
  dispatch({ type: SET_UNITS_LOADING, status: true });
  try {
    await showToast(authorizedAxios.post("/units", data), {
      loading: "Menyimpan unit...",
      success: "Unit berhasil ditambahkan!",
      error: (error) => error?.response?.data?.message || "Gagal menyimpan unit!"
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_UNITS_LOADING, status: false });
  }
};

export const updateUnit = (id, data) => async (dispatch) => {
  dispatch({ type: SET_UNITS_LOADING, status: true });
  try {
    await showToast(authorizedAxios.put(`/units/${id}`, data), {
      loading: "Memperbarui unit...",
      success: "Unit berhasil diperbarui!",
      error: (error) => error?.response?.data?.message || "Gagal memperbarui unit!"
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_UNITS_LOADING, status: false });
  }
};

export const deleteUnit = (id) => async (dispatch) => {
  dispatch({ type: SET_UNITS_LOADING, status: true });
  try {
    await showToast(authorizedAxios.delete(`/units/${id}`), {
      loading: "Menghapus unit...",
      success: "Unit berhasil dihapus!",
      error: (error) => error?.response?.data?.message || "Gagal menghapus unit!"
    });
    return true;
  } catch (error) {
    setError(dispatch, error);
    return false;
  } finally {
    dispatch({ type: SET_UNITS_LOADING, status: false });
  }
};
